import {
  OfertaEscolhidaCustomStatus,
  ProposalConsignadoCustomStatus,
  SeguroEscolhidoCustomStatus,
} from "@/models/consignado/proposal.model";

// Grupos do custom_status que guardam dados da oferta, não passos da esteira —
// ficam fora do histórico de logs.
export const GRUPOS_OFERTA_CUSTOM_STATUS = ["oferta_escolhida", "seguro_escolhido"] as const;

const parseCustomStatus = (
  customStatus: ProposalConsignadoCustomStatus | string | null | undefined
): ProposalConsignadoCustomStatus | null => {
  if (!customStatus) return null;
  if (typeof customStatus !== "string") return customStatus;
  try {
    return JSON.parse(customStatus);
  } catch {
    return null;
  }
};

export interface OfertaEscolhida {
  oferta: OfertaEscolhidaCustomStatus | null;
  seguro: SeguroEscolhidoCustomStatus | null;
  /** Valor do seguro: a apólice tem prioridade, como no back (insuranceAmount || insuranceValue). */
  valorSeguro: number | null;
}

// Oferta e seguro escolhidos da proposta, lidos do custom_status. Proposta sem
// o bloco (anterior ao back gravar) devolve tudo null.
export const getOfertaEscolhida = (
  customStatus: ProposalConsignadoCustomStatus | string | null | undefined
): OfertaEscolhida => {
  const parsed = parseCustomStatus(customStatus);
  const oferta = parsed?.oferta_escolhida ?? null;
  const seguro = parsed?.seguro_escolhido ?? null;
  return {
    oferta,
    seguro,
    valorSeguro: seguro?.insuranceAmount || oferta?.insuranceValue || null,
  };
};
